var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletepopupDeleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5921_220575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4172 52C10.1932 52 9.15286 51.5787 8.29609 50.7361C7.43932 49.8935 7.01094 48.8704 7.01094 47.6667V6.5H4V2.16667H17.8062V0H37.1938V2.16667H51V6.5H47.9891V47.6667C47.9891 48.8222 47.5484 49.8333 46.6672 50.7C45.7859 51.5667 44.7578 52 43.5828 52H11.4172ZM43.5828 6.5H11.4172V47.6667H43.5828V6.5ZM19.2016 41.4556H23.6078V12.6389H19.2016V41.4556ZM31.3922 41.4556H35.7984V12.6389H31.3922V41.4556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01094 6.5V5.5H7.01094H5V3.16667H17.8062H18.8062V2.16667V1H36.1938V2.16667V3.16667H37.1938H50V5.5H47.9891H46.9891V6.5V47.6667C46.9891 48.5341 46.6709 49.2938 45.966 49.987C45.261 50.6803 44.4808 51 43.5828 51H11.4172C10.4501 51 9.66317 50.678 8.99728 50.0231C8.33203 49.3689 8.01094 48.6028 8.01094 47.6667V6.5ZM44.5828 6.5V5.5H43.5828H11.4172H10.4172V6.5V47.6667V48.6667H11.4172H43.5828H44.5828V47.6667V6.5ZM22.6078 13.6389V40.4556H20.2016V13.6389H22.6078ZM34.7984 13.6389V40.4556H32.3922V13.6389H34.7984Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5921_220575",
    x: 0,
    y: 0,
    width: 55,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5921_220575"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5921_220575",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletepopupDeleteicon);
export default __webpack_public_path__ + "static/media/deletepopup_deleteicon.4a7235042b29987354cd70a5414f1851.svg";
export { ForwardRef as ReactComponent };